import { useId } from 'react';

export function useOptionalId(id: string | undefined): string {
	const generatedId = useId();
	return id || generatedId;
}
